export default __webpack_public_path__ + "static/media/Victor_Emmanuel_Resume.21da8d8f.pdf";